import { KeyStagesSlug } from "@twinkltech/curriculum-architect-domain-hooks";

import {
  KEY_STAGE_SORT_ORDER,
  YEAR_ONLY_SLUGS,
} from "../ResourceHelper/utils/sortKeyStageOptions/keyStageConstants";

const getIndex = (slug: string): number => {
  const i = KEY_STAGE_SORT_ORDER.indexOf(slug);
  return i === -1 ? Infinity : i;
};

const getPrimaryPriority = (keyStagesSlug?: KeyStagesSlug[]): number => {
  if (!keyStagesSlug?.length) return Infinity;
  return Math.min(...keyStagesSlug.map((s) => getIndex(s as string)));
};

const getSecondaryPriority = (keyStagesSlug?: KeyStagesSlug[]): number => {
  if (!keyStagesSlug?.length) return Infinity;
  const yearPriorities = keyStagesSlug
    .filter((s) => YEAR_ONLY_SLUGS.has(s as string))
    .map((s) => getIndex(s as string));
  return yearPriorities.length ? Math.min(...yearPriorities) : Infinity;
};

export const sortResourcesByKeyStage = <
  T extends { keyStagesSlug?: KeyStagesSlug[] },
>(
  resources: T[]
): T[] =>
  [...resources].sort((a, b) => {
    const primaryDiff =
      getPrimaryPriority(a.keyStagesSlug) -
      getPrimaryPriority(b.keyStagesSlug);
    if (primaryDiff !== 0 && !Number.isNaN(primaryDiff)) return primaryDiff;
    return (
      getSecondaryPriority(a.keyStagesSlug) -
      getSecondaryPriority(b.keyStagesSlug)
    );
  });
